import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { GateWay } from '../gateway.model';

export enum GateWayDiscoveryActionTypes {
  ReadDiscoveryInfoList = '[GateWay] Read Discovery List',
  UpsertDiscoveryInfoList = '[GateWay] Upsert Discovery Info List',
  ReadDiscoveryInfoListFail = '[GateWay] Read Discovery List Fail',
  UpsertDiscoveryInfo = '[GateWay] Upsert Discovery Info',
  ReadDiscoveryInfo = '[GateWay] Read Discovery Info',
  ReadDiscoveryInfoFail = '[GateWay] Read Discovery Info Fail',
  AddDiscoveryInfo = '[GateWay] Add Discovery Info',
  UpdateDiscoveryInfo = '[GateWay] Update Discovery Info',
  DeleteDiscoveryInfo = '[GateWay] Delete Discovery Info',
  ExecuteDiscoveryList = '[GateWay] Execute Discovery List',
  ExecuteDiscoveryListSuccess = '[GateWay] Execute Discovery List Success',
  ExecuteDiscoveryListFail = '[GateWay] Execute Discovery List Fail',
  ExecuteDiscovery = '[GateWay] Execute Discovery',
  ExecuteDiscoverySuccess = '[GateWay] Execute Discovery Success',
  ExecuteDiscoveryFail = '[GateWay] Execute Discovery Fail',
  StopExecutingDiscovery = '[GateWay] Stop Executing Discovery',
  ConfirmExecutingDiscovery = '[GateWay] Confirm Executing Discovery',
  ReadDiscoveryResultList = '[GateWay] Read Discovery Result List',
  UpsertDiscoveryResultList = '[GateWay] Upsert Discovery Result List',
  ReadDiscoveryResultListFail = '[GateWay] Read Discovery Result List Fail',
  AddDiscoveryResult = '[GateWay] Add Discovery Result',
  ReadDiscoveryExecutingResultForOneTime = '[GateWay] Read Discovery Executing Result For OneTime',
  ReadDiscoveryExecutingResultForOneTimeSuccess = '[GateWay] Read Discovery Executing Result For OneTime Success',
  ReadDiscoveryExecutingResultForOneTimeFail = '[GateWay] Read Discovery Executing Result For OneTime Fail',
}

export class ReadDiscoveryInfoList implements Action {
  readonly type = GateWayDiscoveryActionTypes.ReadDiscoveryInfoList;

  constructor(public payload: any = null) {}
}
export class UpsertDiscoveryInfoList implements Action {
  readonly type = GateWayDiscoveryActionTypes.UpsertDiscoveryInfoList;

  constructor(public payload: any) {}
}
export class ReadDiscoveryInfoListFail implements Action {
  readonly type = GateWayDiscoveryActionTypes.ReadDiscoveryInfoListFail;

  constructor(public payload: any = null) {}
}
export class ReadDiscoveryInfo implements Action {
  readonly type = GateWayDiscoveryActionTypes.ReadDiscoveryInfo;

  constructor(public payload: any = null) {}
}
export class UpsertDiscoveryInfo implements Action {
  readonly type = GateWayDiscoveryActionTypes.UpsertDiscoveryInfo;

  constructor(public payload: any = null) {}
}
export class ReadDiscoveryInfoFail implements Action {
  readonly type = GateWayDiscoveryActionTypes.ReadDiscoveryInfoFail;

  constructor(public payload: any = null) {}
}

export class AddDiscoveryInfo implements Action {
  readonly type = GateWayDiscoveryActionTypes.AddDiscoveryInfo;

  constructor(public payload: any = null) {}
}
export class UpdateDiscoveryInfo implements Action {
  readonly type = GateWayDiscoveryActionTypes.UpdateDiscoveryInfo;

  constructor(public payload: any = null) {}
}
export class DeleteDiscoveryInfo implements Action {
  readonly type = GateWayDiscoveryActionTypes.DeleteDiscoveryInfo;

  constructor(public payload: any = null) {}
}
export class ExecuteDiscovery implements Action {
  readonly type = GateWayDiscoveryActionTypes.ExecuteDiscovery;

  constructor(public payload: any = null) {}
}
export class ExecuteDiscoverySuccess implements Action {
  readonly type = GateWayDiscoveryActionTypes.ExecuteDiscoverySuccess;

  constructor(public payload: any) {}
}
export class ExecuteDiscoveryFail implements Action {
  readonly type = GateWayDiscoveryActionTypes.ExecuteDiscoveryFail;

  constructor(public payload: any = null) {}
}
export class ExecuteDiscoveryList implements Action {
  readonly type = GateWayDiscoveryActionTypes.ExecuteDiscoveryList;

  constructor(public payload: any = null) {}
}
export class ExecuteDiscoveryListSuccess implements Action {
  readonly type = GateWayDiscoveryActionTypes.ExecuteDiscoveryListSuccess;

  constructor(public payload: any) {}
}
export class ExecuteDiscoveryListFail implements Action {
  readonly type = GateWayDiscoveryActionTypes.ExecuteDiscoveryListFail;

  constructor(public payload: any = null) {}
}
export class StopExecutingDiscovery implements Action {
  readonly type = GateWayDiscoveryActionTypes.StopExecutingDiscovery;

  constructor(public payload: any = null) {}
}
export class ConfirmExecutingDiscovery implements Action {
  readonly type = GateWayDiscoveryActionTypes.ConfirmExecutingDiscovery;

  constructor(public payload: any = null) {}
}
export class ReadDiscoveryResultList implements Action {
  readonly type = GateWayDiscoveryActionTypes.ReadDiscoveryResultList;

  constructor(public payload: any = null) {}
}
export class UpsertDiscoveryResultList implements Action {
  readonly type = GateWayDiscoveryActionTypes.UpsertDiscoveryResultList;

  constructor(public payload: any) {}
}
export class ReadDiscoveryResultListFail implements Action {
  readonly type = GateWayDiscoveryActionTypes.ReadDiscoveryResultListFail;

  constructor(public payload: any = null) {}
}
export class AddDiscoveryResult implements Action {
  readonly type = GateWayDiscoveryActionTypes.AddDiscoveryResult;

  constructor(public payload: any = null) {}
}
export class ReadDiscoveryExecutingResultForOneTime implements Action {
  readonly type = GateWayDiscoveryActionTypes.ReadDiscoveryExecutingResultForOneTime;

  constructor(public payload: any = null) {}
}
export class ReadDiscoveryExecutingResultForOneTimeSuccess implements Action {
  readonly type = GateWayDiscoveryActionTypes.ReadDiscoveryExecutingResultForOneTimeSuccess;

  constructor(public payload: any) {}
}
export class ReadDiscoveryExecutingResultForOneTimeFail implements Action {
  readonly type = GateWayDiscoveryActionTypes.ReadDiscoveryExecutingResultForOneTimeFail;

  constructor(public payload: any) {}
}


export type GateWayDiscoveryActions =
ReadDiscoveryInfoList
 | UpsertDiscoveryInfoList
 | ReadDiscoveryInfoListFail
 | ReadDiscoveryInfo
 | UpsertDiscoveryInfo
 | ReadDiscoveryInfoFail
 | AddDiscoveryInfo
 | UpdateDiscoveryInfo
 | DeleteDiscoveryInfo
 | StopExecutingDiscovery
 | ConfirmExecutingDiscovery
 | ExecuteDiscovery
 | ExecuteDiscoverySuccess
 | ExecuteDiscoveryFail
 | ExecuteDiscoveryList
 | ExecuteDiscoveryListSuccess
 | ExecuteDiscoveryListFail
 | ReadDiscoveryResultList
 | UpsertDiscoveryResultList
 | ReadDiscoveryResultListFail
 | AddDiscoveryResult
 | ReadDiscoveryExecutingResultForOneTime
 | ReadDiscoveryExecutingResultForOneTimeSuccess
 | ReadDiscoveryExecutingResultForOneTimeFail
